
import CaseStudiesNavbar from './components/CaseStudiesNavbar';
import CaseStudiesHero from './components/CaseStudiesHero';
import CaseStudiesGrid from './components/CaseStudiesGrid';
import FeaturedCaseStudy from './components/FeaturedCaseStudy';
import ClientTestimonials from './components/ClientTestimonials';
import CaseStudiesCTA from './components/CaseStudiesCTA';
import Footer from '../home/components/Footer';

export default function CaseStudiesPage() {
  return (
    <div className="min-h-screen bg-white">
      <CaseStudiesNavbar />
      <CaseStudiesHero />
      <CaseStudiesGrid />
      <FeaturedCaseStudy />
      <ClientTestimonials />
      <CaseStudiesCTA />
      <Footer />
    </div>
  );
}
